import { Routes } from '@angular/router';
import { PrivateComponent } from './private.component';
import { HomeComponent } from './home/home.component';
import { DettaglioPraticaComponent } from './dettaglio-pratica/dettaglio-pratica.component';
import { ProfiloComponent } from './profilo/profilo.component';
import { DatiPersonaliComponent } from './profilo/dati-personali/dati-personali.component';
import { CambiaPasswordComponent } from './profilo/cambia-password/cambia-password.component';

export const routes: Routes = [
	{
		path: '',
		component: PrivateComponent,
		children: [
			{ path: '', component: HomeComponent },
			{
				path: 'dettaglio/:idTransaction',
				component: DettaglioPraticaComponent,
				data: { hideFooter: true },
			},
			{
				path: 'profilo',
				component: ProfiloComponent,
			},
			{
				path: 'profilo/dati-personali',
				component: DatiPersonaliComponent,
			},
			{
				path: 'profilo/cambia-password',
				component: CambiaPasswordComponent,
			},
			{
				path: 'profilo/storico-pratiche',
				loadComponent: () => import('./profilo/storico-pratiche/storico-pratiche.component').then((m) => m.StoricoPraticheComponent),
			},
			{
				path: 'profilo/storico-pratiche/dettaglio/:id',
				loadComponent: () => import('./profilo/storico-pratiche/dettaglio/storico-pratiche-dettaglio.component').then((m) => m.StoricoPraticheDettaglioComponent),
			},
		],
	},
];
